"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _useAccessory2 = require("../../../../hooks/upsell/useAccessory");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var getColorOptions = function getColorOptions(colors) {
  return colors.map(function (color) {
    var _color$split = color.split('|'),
      _color$split2 = _slicedToArray(_color$split, 2),
      colorValue = _color$split2[0],
      colorName = _color$split2[1];
    return {
      text: colorName,
      value: colorValue,
      color: colorValue
    };
  });
};
var getSizeOptions = function getSizeOptions(sizes) {
  return sizes.map(function (size) {
    var _size$split = size.split('|'),
      _size$split2 = _slicedToArray(_size$split, 2),
      sizeValue = _size$split2[0],
      sizeUnit = _size$split2[1];
    return {
      text: "".concat(sizeValue, " ").concat(sizeUnit),
      value: sizeValue
    };
  });
};
var VariancePicker = function VariancePicker() {
  var _useAccessory = (0, _useAccessory2.useAccessory)(),
    selectionTree = _useAccessory.selectionTree,
    currentVariant = _useAccessory.currentVariant,
    handleVariantChange = _useAccessory.handleVariantChange;
  var colors = getColorOptions(Object.keys(selectionTree.colors));
  var sizes = getSizeOptions(selectionTree.colors[Object.keys(selectionTree.colors)[0]]);
  var initialColor = colors.find(function (color) {
    return currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.color.includes(color.value);
  }) || colors[0];
  var initialSize = sizes.find(function (size) {
    return currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.size.includes(size.value);
  }) || sizes[0];
  var _useState = (0, _react.useState)(initialColor.value),
    _useState2 = _slicedToArray(_useState, 2),
    currentColor = _useState2[0],
    setCurrentColor = _useState2[1];
  var _useState3 = (0, _react.useState)(initialSize.value),
    _useState4 = _slicedToArray(_useState3, 2),
    currentSize = _useState4[0],
    setCurrentSize = _useState4[1];
  var _useState5 = (0, _react.useState)(sizes),
    _useState6 = _slicedToArray(_useState5, 2),
    sizeOptions = _useState6[0],
    setSizeOptions = _useState6[1];
  var handleColorChange = function handleColorChange(color) {
    setCurrentColor(color);
    var colorKey = Object.keys(selectionTree.colors).find(function (key) {
      return key.includes(color);
    });
    var options = getSizeOptions(selectionTree.colors[colorKey]);
    setSizeOptions(options);
    setCurrentSize(options[0].value);
    handleVariantChange(color, options[0].value);
  };
  var handleSizeChange = function handleSizeChange(size) {
    setCurrentSize(size);
    handleVariantChange(currentColor, size);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.ColorSelectWithLabel, {
    fieldWrapper: {
      label: "Select Color",
      width: 'full'
    },
    colorSelect: {
      id: "smartwatch-color",
      value: currentColor,
      onChange: handleColorChange,
      options: colors
    }
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SelectInputWithMenuWithLabel, {
    fieldWrapper: {
      label: "Select Size",
      width: 'full'
    },
    selectInputWithMenu: {
      id: "smartwatch-size",
      required: true,
      value: currentSize,
      onChange: handleSizeChange,
      options: sizeOptions
    }
  })));
};
var _default = VariancePicker;
exports.default = _default;